/**
 * Configuration runtime pour l'environnement
 * Note: Les URLs des workers sont centralisées dans commons-shared/workers-config.js
 */

import debug from '@commons-shared/debug.js';

export const getConfig = () => {
  const isDev = import.meta.env.DEV || import.meta.env.VITE_NODE_ENV === 'development';
  const isLocalhost = typeof window !== 'undefined' && window.location.hostname === 'localhost';
  
  // Configuration de l'application (sans les URLs des workers)
  const config = {
    DEBUG_MODE: import.meta.env.VITE_DEBUG_MODE || 'true',
    NODE_ENV: (isDev || isLocalhost) ? 'development' : 'production'
  };
  
  debug.log(config, 'Configuration application:', config);
  
  return config;
}

// Export direct pour compatibilité
export const config = getConfig();